import Div from '@jarvis.oddle/core/components/Div'
import { Column } from '@jarvis.oddle/core/components/Grid'
import IconMapDragPin from '@jarvis.oddle/core/components/Icons/IconMapDragPin'
import { margin, marginSizes } from '@jarvis.oddle/core/theme/default'
import GoogleMapService from 'src/containers/MapService/GoogleMapService'
import React from 'react'
import styled from 'styled-components'
import useAppSelector from 'src/hooks/useAppSelector'
import { selectCheckout } from 'src/redux/checkout'
import { selectStore } from 'src/redux/stores'

const MapWrapper = styled(Div)`
  position: relative;
  height: 220px;
  width: 100%;
`

const MapMarker = styled(IconMapDragPin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
`

const MapContainer = styled(Div)`
  height: 220px;
`

const StyledMapSection = styled(Column)`
  margin-bottom: ${margin[marginSizes.medium]};
`

const retrieveStoresList = (availableStores) =>
  availableStores.reduce((obj, item) => ({ ...obj, [item.id]: item }), {})

interface Summary {
  MapComponent
  getMapProps
}

const StoreAddressMap = ({
  MapComponent,
  getMapProps
}: Summary): JSX.Element => {
  const checkoutState = useAppSelector(selectCheckout)
  const storeState = useAppSelector(selectStore)

  const storeOrder = { data: checkoutState.meta.data.storeOrder }

  const mapOptions = {
    draggable: false,
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    fullscreenControl: false,
    clickableIcons: false,
    draggableCursor: 'default'
  }
  const isPickup = storeOrder.data.isPickup
  let latitude, longitude

  if (isPickup) {
    const store = retrieveStoresList(storeState.data || [])[
      storeOrder.data.storeId
    ]
    latitude = store?.latitude
    longitude = store?.longitude
  } else {
    latitude = storeOrder.data.customerLatitude
    longitude = storeOrder.data.customerLongitude
  }

  return (
    <StyledMapSection sm={12} md={6}>
      <MapWrapper>
        <MapComponent
          {...getMapProps()}
          mapOptions={mapOptions}
          Container={MapContainer}
          initialCenter={{ latitude, longitude }}
        />
        <MapMarker />
      </MapWrapper>
    </StyledMapSection>
  )
}

const WrappedStoreAddressMap = (): JSX.Element => {
  return (
    <GoogleMapService>
      {({ getMapProps, MapComponent }) => (
        <StoreAddressMap
          getMapProps={getMapProps}
          MapComponent={MapComponent}
        />
      )}
    </GoogleMapService>
  )
}

export default WrappedStoreAddressMap
